module.exports = __webpack_public_path__ + "pc/img/award2022_01.8f842ac9.png";